import { formatDistanceStrict as baseFormatDistanceStrict } from "date-fns/formatDistanceStrict"
import { isBefore as baseIsBefore } from "date-fns/isBefore"
import { enGB, fr } from "date-fns/locale"

const localeToDateFnsLocale = { en: enGB, fr: fr }

function getCurrentLocale() {
  return localeToDateFnsLocale[window.__dateFnsLocale__]
}

export function formatDistanceStrict(date, baseDate) {
  return baseFormatDistanceStrict(date, baseDate, {
    locale: getCurrentLocale(),
  })
}

export function isBefore(date, dateToCompare) {
  return baseIsBefore(date, dateToCompare, { locale: getCurrentLocale() })
}

/**
 * @param {string} dateString
 * @returns {string}
 */
export function sanitizeDateString(dateString) {
  if (!dateString) return dateString

  return dateString.replace("+00:00", "").replace(/\.\d+Z?$/, "")
}
